import { ViewDto } from './viewdto';

export class DeleteReq {
  idList: any[] = [];
  isfavori: boolean = false;
  ownerid: any;
  view: any;
}
